import { render, staticRenderFns } from "./taxPasswordExample.vue?vue&type=template&id=51536a9a&scoped=true&"
import script from "./taxPasswordExample.vue?vue&type=script&lang=js&"
export * from "./taxPasswordExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51536a9a",
  null
  
)

export default component.exports